export default "__VITE_ASSET__CSfCNLcU__"